import { z } from "zod";
import { RegisterEmployeeSchema } from "./add-employee";


export const EditEmployeeSchema = RegisterEmployeeSchema.partial().extend({
  stateDistricts: z
    .array(
      z.object({
        state: z.string().optional().default(""),
        districts: z.array(z.string()).default([]),
      }),
    )
    .optional()
    .default([]),
  start_date: z.string().nullable().optional(),
});

export type EditEmployeeFormValues = z.infer<typeof EditEmployeeSchema>;
